import type { TransactionType } from "./types";

export const qk = {
  /** 플롯 목록·상세. 서버가 {{user}} 를 보는 사람의 대표 프로필 이름으로 치환하므로 키에 viewer(usePlotViewer) — 로그인·로그아웃·프로필 변경 시 다시 받는다 (AC0-359) */
  plots: (viewer: string) => ["plots", viewer] as const,
  plot: (id: string, viewer: string) => ["plot", id, viewer] as const,
  conversation: (plotId: string) => ["conversation", plotId] as const,
  /** 대화 탭 목록. 키에 사용자 id — 계정이 바뀌면 남의 목록을 보이지 않는다 */
  conversationList: (userId: string) => ["conversationList", userId] as const,
  me: ["me"] as const,
  meProfiles: ["me", "profiles"] as const,
  consents: ["me", "consents"] as const,
  bricks: ["bricks"] as const,
  products: ["products"] as const,
  transactions: (type: TransactionType) => ["transactions", type] as const,
} as const;
